export default __webpack_public_path__ + "static/media/button-replay-1.ea430e83.png";